import { IPageConfiguration } from '../../../domain/conf/page'
import { Entity } from '../../../domain/entity'
import { IProfile } from '../../common/profile'
import { IProviderConfig } from '../../common/provider-config'

export enum SSOScreen {
    LOG_IN = 'login',
    SIGN_IN = 'signIn',
    SIGN_OUT = 'signOut'
}

export interface IIdentityServiceAdapter {
    enable?(): void
    fetch?(): IProfile
    hasSession(): Promise<boolean> | boolean // TODO temporary, remove when piano LR is implemented
    registerInitHandler?(): void
    signIn(commentRedirect?: boolean): void
    signOut(): void
    closeModal?(): void
    removeCommentWidgetsAdUI?(): void
    getAccessToken?(): string
}

export interface ISubscriberServiceAdapter  {
    getConversions(): Promise<string[]>
    getAccess(): Promise<ISubscription[]>
    registerForOneDigital(aid: string): Promise<void>
    closeCheckoutModal(): void
    showCheckoutModal(offerId: string, termId: string): void
}

export interface IIdentityProviderConfig extends IProviderConfig {
    application?: string
    page?: IPageConfiguration
    showPasswordPolicy?: boolean
    vendor?: string
    loginradius?: IIdentityLoginRadiusConfig
}

export interface ISubscriberProviderConfig extends IIdentityProviderConfig {
    /**
     * Whitelist of subscription ids that determine if a user is a subscriber.
     */
    resIds?: string[]

    /**
     * For One Digital properties, the basic digital access term provided to all registrants.
     * @nullable
     */
    registrantTermId?: string

    /**
     * The basic digital access term resource id
     * @nullable
     */
    registrantResId?: string
}

export type TermType =
    | 'registration'
    | 'payment'
    | 'grant_access'
    | 'external'
    | 'custom'
    | 'gift'
    | undefined

export interface ISubscription {
    end?: number
    aid?: string
    id: string
    start: number
    termId?: string
    termType?: TermType
    isActiveRegistration?(): boolean
    isDefaultRegistrationAccess?(): boolean
}

export class Subscription extends Entity implements ISubscription {
    public end?: number
    public aid?: string
    public id: string
    public start: number
    public termId: string
    public termType: TermType

    constructor({ id, aid, start, end, termId, termType }: ISubscription = {} as ISubscription) {
        super()
        this.id = id
        this.aid = aid
        this.start = start
        this.end = end
        this.termId = termId
        this.termType = termType
    }

    /** Return whether subscription is active or not based on the given `start` and `end` timestamps */
    public isActiveRegistration(): boolean {
        const now: number = Date.now()
        // not all subscription has expire_date (ie: end)
        return this.end ? (this.start <= now && now <= this.end) : this.start <= now
    }

    /** Returns whether subscription is default registration access or not */
    public isDefaultRegistrationAccess(): boolean {
        if (typeof this.termType === 'undefined' || this.termType === null) {
            return undefined
        } else {
            return this.termType === 'registration'
        }
    }
}

export interface IIdentityLinksConfig {
    contact_us?: IIdentityLinkConfig,
    copyright?: IIdentityLinkConfig
    privacy_updated?: IIdentityLinkConfig
    site_map?: IIdentityLinkConfig
    terms?: IIdentityLinkConfig
}

export interface IIdentityLinkConfig {
    a_title?: string,
    link?: string
    title?: string
}

export interface IIdentityLoginRadiusConfig {
    appName?: string,
    apiKey?: string
}
